/* eslint-disable max-len */
var meten = require('../utils/meten_helper');

jQuery(document).ready(function ($) {
  'use strict';

  var selected, personalizationData, modal, buttonPopupTitel, buttonPopupTekst, buttonPopupButtonTekst, buttonPopupClass, buttonPopupAriaLabel, buttonPopupImg, buttonPopupImgAlt, popup, root, popupModal;
  const timeoutms = 4000;

  function personalisationNavigate(data) {
    // Due to a script for personalisation the time-out and popup don't work. So the session storage is removed
    sessionStorage.removeItem('feedbackQueue');
    personalizationFunctions.sendFeedbackAndNavigate(data, selected);
  }

  function popupPage(data) {
    modal = $('.popup-ext-url.modalBetweenPage');
    modal.backdrop = 'static';
    window.helper.showModal(modal);

    if ($('.js-naar-ext-url').length) {
      $('.js-naar-ext-url').on('click', function() {
        if (data && personalizationFunctions && !selected.includes(window.location.host)) {
          personalisationNavigate(data);
        } else {
          window.open(selected, '_blank');
        }
        window.helper.hideModal(modal);
      });
    } else {
      // no rabo button, then automatic redirect with time-out
      setTimeout(function() {
        if (data && personalizationFunctions && !selected.includes(window.location.host)) {
          personalisationNavigate(data);
        } else {
          window.location = selected;
        }
      }, timeoutms);
    }
  }

  /* eslint-disable max-statements */
  function popupButton(data) {
    var paza = document.body.getAttribute('data-paza'),
        pagename = document.body.getAttribute('data-pagename'),
        meetid = 'ipoclick-btn-' + paza + '-' + pagename + '-' + buttonPopupButtonTekst.toLowerCase().replace(new RegExp(' ', 'g'), '_');

    popup = '<div class="popup-ext-url-button ' + buttonPopupClass + '" tab-index="-1" aria-hidden="false">' +
      '<div class="modal__window" role="dialog document" aria-label="' + buttonPopupAriaLabel + '">' +
      '<focus-trap tabindex="0"><div class="modal__inner"><div class="modal__content"><div class="uitleg-naar">' +
      '<img src="' + buttonPopupImg + '" alt="' + buttonPopupImgAlt + '">' +
      '<h2 class="uitleg-naar__title">' + buttonPopupTitel + '</h2>' +
      '<div class="uitleg-naar__text">' + buttonPopupTekst + '</div>' +
      '<button class="button button--purple js-naar-ext-url" data-meetid="' + meetid + '">' + buttonPopupButtonTekst + '</button></div></div>' +
      '<button class="close-button js-close-button has-ripple" role="button" aria-label="Sluit venster" tabindex="0" data-meetid="' + meetid + '-close_modal">' +
      '<span class="ial-fu_018"></span></button></div></focus-trap></div></div>';
    popupModal = document.createElement('div');
    popupModal.classList.add('popup-ext-url-button-modal', 'modal');
    popupModal.innerHTML = popup;
    root = document.getElementsByTagName('body')[0];
    if ($('.popup-ext-url-button-modal').length) {
      $('.popup-ext-url-button-modal').remove();
    }

    root.appendChild(popupModal);
    modal = $('.popup-ext-url-button-modal');
    modal.backdrop = 'static';
    window.helper.showModal(modal);
    meten.resetAll();

    $('.popup-ext-url-button-modal .js-naar-ext-url').on('click', function() {
      if (data && personalizationFunctions && !selected.includes(window.location.host)) {
        personalisationNavigate(data);
      } else {
        window.open(selected, '_blank');
      }
      window.helper.hideModal(modal);
    });
    $('.popup-ext-url-button-modal .js-close-button').on('click', function() {
      window.helper.hideModal(modal);
    });
  }

  function registerClick() {
    $('#main a.button--rabo, #main .page-hero .page-hero__links a, #main .js-ext-url').on('click', function(evt) {
      evt.preventDefault();
      selected = $(this).attr('href');

      if (selected) {
        if ($(this).attr('data-personalization-data')) {
          personalizationData = JSON.parse($(this).attr('data-personalization-data'));
        }
        if ($('.js-ext-url') && $(this).attr('data-popup-tekst')) {
          buttonPopupClass = $(this).attr('data-popup-class');
          buttonPopupAriaLabel = $(this).attr('data-popup-arialabel');
          buttonPopupImg = $(this).attr('data-popup-image');
          buttonPopupImgAlt = $(this).attr('data-popup-image-alt');
          buttonPopupTitel = $(this).attr('data-popup-titel');
          buttonPopupTekst = $(this).attr('data-popup-tekst');
          buttonPopupButtonTekst = $(this).attr('data-popup-btekst');
          popupButton(personalizationData);
        } else {
          popupPage(personalizationData);
        }
      }
    });
  }

  // Open popup for all rabo buttons and page hero links
  if ($('.popup-ext-url').length && $('#main a.button--rabo, #main .page-hero .page-hero__links a, #main .js-ext-url').length) {
    registerClick();
  }

  window.addEventListener('msmpopup:klaar', async function () {
    registerClick();
  });
  /* eslint-enable max-statements */
});